import { makeStyles, tokens } from '@fluentui/react-components';

export const useIconTextStyles = makeStyles({
    root: {
        '@media screen and (max-width: 1400px)': {
            display: 'none'
        }
    },
    icon: {
        marginLeft: tokens.spacingVerticalSNudge,
        marginRight: tokens.spacingVerticalSNudge
    },
    inverted: {
        color: tokens.colorNeutralForegroundInverted
    },
    onlyIcon: {
        display: 'none',
        alignSelf: 'center',
        cursor: 'pointer',
        '@media screen and (max-width: 1400px)': {
            display: 'block'
        }
    }
});
